module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av346-63e35b1a777d105a14d76049ed70e031.jpg";